import { RouteConfig } from "vue-router";

export const routes: Array<RouteConfig> = [
	{
		path: "/account-management/graph/users",
		name: "AccountManagement-Graph-UsersList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "account-management" */ "@/views/account-management/graph/users/UsersList.vue"),
	},
	{
		path: "/account-management/graph/credentials",
		name: "AccountManagement-Graph-CredentialsList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "account-management" */ "@/views/account-management/graph/credentials/CredentialsList.vue"),
	},
	{
		path: "/account-management/ebi/users",
		name: "AccountManagement-Ebi-UsersList",
		// route level code-splitting
		// this generates a separate chunk (about.[hash].js) for this route
		// which is lazy-loaded when the route is visited.
		component: () =>
			import(/* webpackChunkName: "account-management" */ "@/views/account-management/ebi/users/UsersList.vue"),
	},
];
